import s from './Services.module.css'
import {Link} from "react-router-dom";
import CostReduction from "../../assets/img/CostReduction/CostReductionBG.webp";
import StaffAccommodation from "../../assets/img/StaffAccommodation/StaffAccommodationBG.webp";
import HrConsultancy from "../../assets/img/HrConsultancy/HrConsultancyBG.jpg";


export const Services = () => {
    return (
        <div className={s.Services}>
            <div className={s.ServicesBG}>
                <h3>Services</h3>
            </div>
            <div className="container">
                <div className={s.parent}>
                    <Link to={'/CostReduction'}  className={`${s.CostReduction} ${s.div1}`}>
                        <div>
                            <img src={CostReduction} alt="Cost Reduction"/>
                            <p>Cost Reduction</p>
                        </div>
                    </Link>
                    <Link to={'/StaffAccommodation'} className={`${s.StaffAccommodation} ${s.div2}`}>
                        <div >
                            <img src={StaffAccommodation} alt="Staff Accommodation"/>
                            <p>Staff Accommodation</p>
                        </div>
                    </Link>
                    <Link to={'/HrConsultancy'} className={`${s.HrConsultancy} ${s.div3}`}>
                        <div>
                            <img src={HrConsultancy} alt="HR Consultancy"/>
                            <p>HR Consultancy</p>
                        </div>
                    </Link>

                </div>
            </div>

        </div>
    )
}